// 🚨 AUTO-GENERADO desde QuoteDataType.ts - No editar manualmente

export const QuoteFormDataKeys = [
  "id",
  "numero",
  "nombre_factura",
  "tipo_identificacion",
  "identificacion",
  "tel1",
  "tel1_cd",
  "tel2",
  "tel2_cd",
  "email",
  "direccion",
  "clientActivitycode",
  "activitycode",
  "fecha",
  "cerrada",
  "approval_status",
  "porcenta_descuento",
  "descuento",
  "discountCode",
  "subtotal",
  "impuestos",
  "impuestos_servicio",
  "total",
  "reserved_until",
  "comments",
  "exchange_rate",
  "customfields",
  "otros_cargos",
  "reference_number",
  "selected_logo",
  "exenta",
  "descuento_con_nota",
  "clientId",
  "client",
  "currencyId",
  "currency",
  "quoteProducts",
  "user",
  "razon_social",
  "plazo"
] as const;
